import { useNavigate } from 'react-router-dom'
import ToolCard from '../../components/gpt/ToolCard'
import QuestionsWrapper from '../../components/gpt/QuestionsWrapper'
import { useI18N } from '../../../libraries/i18n/hook'

const GptForm = () => {
  const { t } = useI18N()
  const navigate = useNavigate()


  return (
    <>
      <h1 className='mb-6 mt-0'>{t('studioAi.home.title')}</h1>
      <p className='text-black font-light mb-8'>{t('studioAi.home.subtitle')}</p>
      <QuestionsWrapper>
        <ToolCard onClick={() => navigate('/cv-roaster')} title={t('studioAi.home.cvRoaster')} subtitle={t('studioAi.home.cvRoaster.subtitle')} isPremium />
        <ToolCard onClick={() => navigate('/ai-interview')} title={t('studioAi.home.aiInterview')} subtitle={t('studioAi.home.aiInterview.subtitle')} isPremium />
        <ToolCard onClick={() => navigate('/advisor-ai')} title={t('studioAi.home.advisorAi')} subtitle={t('studioAi.home.advisorAi.subtitle')} />
      </QuestionsWrapper>
    </>
  )
}

export default GptForm
